module.exports = __webpack_public_path__ + "static/images/containers/Schedule/images/halo_top.819b8d9f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Schedule/images/halo_top.png
// module id = 3252
// module chunks = 11